module.exports = __webpack_public_path__ + "8fccf69cd989024ac02fd9af0ce0843a.ttf";